// extracted by mini-css-extract-plugin
export var active = "_88-a";
export var activeIndicator = "_88-8";
export var animate = "_88-9";
export var disabled = "_88-b";
export var fullWidth = "_88-2";
export var lg = "_88-7";
export var md = "_88-6";
export var redoButtonTabGroup = "_88-0";
export var sm = "_88-5";
export var tabButton = "_88-3";
export var tabButtonsContainer = "_88-1";
export var xs = "_88-4";